import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import "./css/style.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import AOS from "aos";

// From appfairy integration of webflow project
import "./styles";
import "./scripts";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";

function App() {
  const location = useLocation();

  useEffect(() => {
    AOS.init({
      once: true,
      disable: "phone",
      duration: 600,
      easing: "ease-out-sine",
    });
  });

  useEffect(() => {
    document.querySelector("html").style.scrollBehavior = "auto";
    window.scroll({ top: 0 });
    document.querySelector("html").style.scrollBehavior = "";
  }, [location.pathname]); // triggered on route change

  // //hubspot integration
  // useEffect(() => {
  //   var _hsq = window._hsq = window._hsq || [];
  //   _hsq.push(['setPath', location.pathname]);
  //   _hsq.push(['trackPageView']);
  // }, [location.pathname]); // triggered on route change

  return (
    <>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/index" element={<Index />} />
        <Route path="/index.html" element={<Index />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;
